import React from 'react';
// @ts-ignore
import styles from './TimePicker.module.scss';
import { registerLocale } from 'react-datepicker';
import { cs, sk, es, enGB, hu, uk, ru, de, fr } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import { default as RcTimePicker } from 'rc-time-picker';
import moment, { Moment } from 'moment';
import useTranslation from '../../../Hooks/useTranslation';
import { useRef } from 'react';

const ll = {
	cs: cs,
	sk: sk,
	hu: hu,
	en: enGB,
	ru: ru,
	uk: uk,
	es: es,
	de: de,
	fr: fr,
};
for (const l in ll) {
	registerLocale(l, ll[l]);
}

interface ITimePicker {
	onChange?: any;
	value?: Moment | string;
	placeholder?: string;
	required?: boolean;
	minuteStep?: number;
	hourStep?: number;
	style?: any;
}

export default function TimePicker(props: ITimePicker) {
	const {
		onChange,
		value = null,
		hourStep,
		minuteStep,
		placeholder,
		style,
	} = props;
	const { t } = useTranslation();
	const wrapperElement = useRef();

	const handleOnChange = e => {
		onChange?.(e);
	};

	//pridat autofocus
	//přidat enter an focus out

	return (
		<div className={styles.wrapper} ref={wrapperElement} style={style}>
			<RcTimePicker
				placeholder={placeholder ? t(placeholder) : undefined}
				showSecond={false}
				onChange={handleOnChange}
				format={'HH:mm'}
				value={typeof value === 'string' ? moment(value) : value}
				defaultValue={value}
				hourStep={hourStep}
				minuteStep={minuteStep}
				focusOnOpen={true}
				getPopupContainer={node => {
					return wrapperElement.current;
				}}
			/>
		</div>
	);
}
